import { render } from "./LicenseAgreement.vue?vue&type=template&id=26bdbb0e&scoped=true"
import script from "./LicenseAgreement.vue?vue&type=script&lang=js"
export * from "./LicenseAgreement.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-26bdbb0e"

export default script